module.exports = __webpack_public_path__ + "img/trash-alt-regular.108cbe00.svg";